export class IntencaoDepositoResponseModel {
    constructor() { }

    public agencia: string;
    public banco: string;
    public cnpj: number;
    public contaBancaria: string;
    public depositoGuid: string;
    public identificador: number;
    public instituicao: string;
    public banrazaoSocialco: string;
    public valor: number;

    public Clear() {
        this.agencia = '';
        this.banco = '';
        this.cnpj = 0;
        this.contaBancaria = '';
        this.depositoGuid = '';
        this.identificador = 0;
        this.instituicao = '';
        this.banrazaoSocialco = '';
        this.valor = 0;
    }
}

